import React from "react";
import { useSelector } from "react-redux";
import { TRAPSEVERITYLIST } from "../../../globals/globals";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { testSNMPTraps } from "../../../globals/constants";
import { RadixSelectControl } from "../../ui/radix-select";
import { Label } from "../../ui/label";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

export const TestSnmpTrap = () => {

    const dispatch = useStoreDispatch();
    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);

    const onInputChange = (name: string, value: string) => {
        if (!!value && name === "trapTarget" && Number(value) < 0) {
            return;
        }
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
    };

    const selectChangeHandler = (name: string) => (value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
    };

    const onBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (!value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "Trap Target is required!" }));
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <div className="space-y-2">
                <Label className="mb-3">Test SNMP Trap Name</Label>
                <RadixSelectControl
                    options={testSNMPTraps.map((item: string) => ({ value: item, label: item }))}
                    value={scheduledtasks?.trapName}
                    placeholder="__placeholder__"
                    onValueChange={selectChangeHandler("trapName")}
                />
            </div>
            <div>
                <InputField
                    label="Test SNMP Trap Target"
                    name="trapTarget"
                    value={scheduledtasks?.trapTarget ?? ""}
                    type="number"
                    onChange={onInputChange}
                    onBlur={onBlurHandler}
                    placeholder="Enter snmp trap target"
                />
            </div>
            <div className="space-y-2">
                <Label className="mb-3">Test SNMP Trap Severity</Label>
                <RadixSelectControl
                    options={TRAPSEVERITYLIST.map((item: string) => ({ value: item, label: item }))}
                    value={scheduledtasks?.trapSeverity}
                    placeholder="__placeholder__"
                    onValueChange={selectChangeHandler("trapSeverity")}
                />
            </div>
        </div>
    );
};